import React, { FC, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import '../../Common/FeaturedProjects/FeaturedProjects.css';
import Loader from '../../../Loader';
import { useGalleryStore } from '../../../../store/useGalleryStore';
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import './ImageGallery.css';
import lgShare from 'lightgallery/plugins/share';
import lgHash from 'lightgallery/plugins/hash';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { Images } from "../../../../assets/assets";

export default function FeaturedGallery() {
  let { getgalleryimage, gallery } = useGalleryStore();

  const [loading, setLoading] = useState(false)
  const [pageSize, setPageSize] = useState(6);
  const [totalItems, setTotalItems] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);

  const getPageData = async () => {
    setLoading(true)
    const res = await getgalleryimage('', '', '', '',);
    if (res) {
      setTotalItems(res?.totalItems);
      console.log(res);
    }
    setLoading(false)
  };

  useEffect(() => {
    getPageData();
  }, [pageNumber, pageSize]);

  const handleChangePagination = (event, value) => {
    setPageNumber(event);
  };

  useEffect(() => {
    // Ensure the DOM element exists
    const container = document.querySelector('.masonry-gallery-demo');
    if (container) {
      // Initialize Masonry
      const msnry = new Masonry(container, {
        itemSelector: '.gallery-item',
        columnWidth: '.grid-sizer',
        percentPosition: true,
      });

      // Use imagesLoaded with Masonry
      imagesLoaded(container).on('progress', function () {
        // Layout Masonry after each image loads
        msnry.layout();
      });
    }
  }, []);
  return (
    <section className="featured-projects">
      <Loader loading={loading}>
        {/* { */}
        {/* //   (gallery.length > 0 ).map((ele, idx) => ( */}
        {gallery.length > 0 ? (
          <div className="pb-5 mb-3">
            <Container>
              <div className="text-center">
                <p className="section-subtitle">Featured Gallery</p>
                <h3 className="section-title">
                  {/* {projectPage?.title} */}
                  {gallery[0].title}
                </h3>
                <p className="section-desc text-light-gray fs-6 mt-xl-3 mt-3 d-block mb-xl-4 mb-lg-4 mb-3">
                  <p>
                    {gallery[0].description?.split("\n").map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                </p>
              </div>
            </Container>
            <Container className="theme-container">
              <div className="gap-3 d-flex flex-wrap justify-content-center galleryMainWidth">
                {(gallery[0].image || []).map((proj, index) => (
                  <div key={index} className="galleryWidthimg">
                    <div className="gallery-card">
                      <LightGallery
                        elementClassNames={"masonry-gallery-demo"}
                        plugins={[lgZoom, lgShare, lgHash]}
                        speed={500}
                      >
                        <div className="grid-sizer"></div>
                        <div
                          className="gallery-item"
                          data-src={proj?.imageLink}
                        >
                          <img
                            className="img-fluid"
                            src={proj?.imageLink}
                            alt="gallery"
                          />
                        </div>
                      </LightGallery>
                    </div>
                  </div>
                ))}
              </div>
            </Container>
            <div className="text-center mt-4">
              <Link to="/gallery" className="viewFullLink btn btn-solid-black text-center">
                
                <span className="fw-bold me-3">View Full Gallery</span>
                <img
                  className="img-fluid"
                  src={Images.FancyWhiteCornerIcon}
                  alt="Phone icon"
                />
              </Link>
            </div>
          </div>
        ) : (
          //   ))
          // }
          <p>No data available.</p>
        )}
      </Loader>

      {/* <div className="paginationDiv">

        <PaginationBar
          totalItems={totalItems}
          pageSize={pageSize}
          currentPage={pageNumber}
          handleChangePagination={handleChangePagination}
        />
      </div> */}
    </section>
  );
}
